export default __webpack_public_path__ + "static/media/tie_3.820507f5.mp3";